import { Avatar, AvatarProps } from "@mui/material"
import { DefaultProfile } from "@/components/icon/svg"
import { getImagePath } from "@/utils/image"
import { colorTokens } from "@/components/colorTokens"

type ProfileAvatarProps = {
  imageUrl?: string | null
  size?: number
} & Omit<AvatarProps, "src">

export default function ProfileAvatar({ imageUrl, size = 42, sx, ...props }: ProfileAvatarProps) {
  const imageSrc = imageUrl ? getImagePath(imageUrl) : undefined

  return (
    <Avatar
      src={imageSrc || "/images/person.png"}
      sx={{
        height: size,
        width: size,
        borderRadius: size,
        backgroundColor: colorTokens.icon.disabled,
        ...sx,
      }}
      {...props}
    />
  )
}
